export default __webpack_public_path__ + "static/CASH24-7.png";